<template>
  <div>
    <h2 class="col-lg-12 text-center mb-3">Editar ferramenta</h2>
    <FormTool :baseTool="tool" @submit-requested="submitRequested"></FormTool>
  </div>
</template>
 
<script>
import { mapState, mapActions } from 'vuex'
import FormTool from '../forms/FormTool.vue'
import router from '@/router';

  export default {
  components: { FormTool },
    computed:{
      ...mapState('tools', ['toolOutput']),
      tool: function()
      {
        return this.toolOutput && this.toolOutput.obj ? this.toolOutput.obj.tool : null;
      }
    },
    methods: {
      ...mapActions('tools', ['editTool']),
      ...mapActions('tools', ['getTool']),
      submitRequested (tool) {
        this.editTool(tool);
      },
    },
    mounted: function()
    {
      if(!this.$route.params.id)
      {
        router.push({ path: '/ferramentas/lista' });
      }
      else
      {
        this.getTool(this.$route.params.id);
      }
    }
  }
</script> 
 
<style scoped>
</style> 